// extracted by mini-css-extract-plugin
export default {"contentWrapper":"PublicHomepage_contentWrapper__palXj"};